/**
 * @fileoverview gRPC-Web generated client stub for importer
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: importer/importer.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.importer = require('./importer_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.importer.GrcImportClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.importer.GrcImportPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.importer.GetImportableTypesRequest,
 *   !proto.importer.GetImportableTypesResponse>}
 */
const methodDescriptor_GrcImport_GetImportableTypes = new grpc.web.MethodDescriptor(
  '/importer.GrcImport/GetImportableTypes',
  grpc.web.MethodType.UNARY,
  proto.importer.GetImportableTypesRequest,
  proto.importer.GetImportableTypesResponse,
  /**
   * @param {!proto.importer.GetImportableTypesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.importer.GetImportableTypesResponse.deserializeBinary
);


/**
 * @param {!proto.importer.GetImportableTypesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.importer.GetImportableTypesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.importer.GetImportableTypesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.importer.GrcImportClient.prototype.getImportableTypes =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/importer.GrcImport/GetImportableTypes',
      request,
      metadata || {},
      methodDescriptor_GrcImport_GetImportableTypes,
      callback);
};


/**
 * @param {!proto.importer.GetImportableTypesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.importer.GetImportableTypesResponse>}
 *     Promise that resolves to the response
 */
proto.importer.GrcImportPromiseClient.prototype.getImportableTypes =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/importer.GrcImport/GetImportableTypes',
      request,
      metadata || {},
      methodDescriptor_GrcImport_GetImportableTypes);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.importer.GetFrameworksRequest,
 *   !proto.importer.GetFrameworksResponse>}
 */
const methodDescriptor_GrcImport_GetFrameworks = new grpc.web.MethodDescriptor(
  '/importer.GrcImport/GetFrameworks',
  grpc.web.MethodType.UNARY,
  proto.importer.GetFrameworksRequest,
  proto.importer.GetFrameworksResponse,
  /**
   * @param {!proto.importer.GetFrameworksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.importer.GetFrameworksResponse.deserializeBinary
);


/**
 * @param {!proto.importer.GetFrameworksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.importer.GetFrameworksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.importer.GetFrameworksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.importer.GrcImportClient.prototype.getFrameworks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/importer.GrcImport/GetFrameworks',
      request,
      metadata || {},
      methodDescriptor_GrcImport_GetFrameworks,
      callback);
};


/**
 * @param {!proto.importer.GetFrameworksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.importer.GetFrameworksResponse>}
 *     Promise that resolves to the response
 */
proto.importer.GrcImportPromiseClient.prototype.getFrameworks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/importer.GrcImport/GetFrameworks',
      request,
      metadata || {},
      methodDescriptor_GrcImport_GetFrameworks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.importer.ImportWizardStartRequest,
 *   !proto.importer.ImportWizardStartResponse>}
 */
const methodDescriptor_GrcImport_ImportWizardStart = new grpc.web.MethodDescriptor(
  '/importer.GrcImport/ImportWizardStart',
  grpc.web.MethodType.UNARY,
  proto.importer.ImportWizardStartRequest,
  proto.importer.ImportWizardStartResponse,
  /**
   * @param {!proto.importer.ImportWizardStartRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.importer.ImportWizardStartResponse.deserializeBinary
);


/**
 * @param {!proto.importer.ImportWizardStartRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.importer.ImportWizardStartResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.importer.ImportWizardStartResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.importer.GrcImportClient.prototype.importWizardStart =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/importer.GrcImport/ImportWizardStart',
      request,
      metadata || {},
      methodDescriptor_GrcImport_ImportWizardStart,
      callback);
};


/**
 * @param {!proto.importer.ImportWizardStartRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.importer.ImportWizardStartResponse>}
 *     Promise that resolves to the response
 */
proto.importer.GrcImportPromiseClient.prototype.importWizardStart =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/importer.GrcImport/ImportWizardStart',
      request,
      metadata || {},
      methodDescriptor_GrcImport_ImportWizardStart);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.importer.GetImportWizardRequest,
 *   !proto.importer.GetImportWizardResponse>}
 */
const methodDescriptor_GrcImport_GetImportWizardStatus = new grpc.web.MethodDescriptor(
  '/importer.GrcImport/GetImportWizardStatus',
  grpc.web.MethodType.UNARY,
  proto.importer.GetImportWizardRequest,
  proto.importer.GetImportWizardResponse,
  /**
   * @param {!proto.importer.GetImportWizardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.importer.GetImportWizardResponse.deserializeBinary
);


/**
 * @param {!proto.importer.GetImportWizardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.importer.GetImportWizardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.importer.GetImportWizardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.importer.GrcImportClient.prototype.getImportWizardStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/importer.GrcImport/GetImportWizardStatus',
      request,
      metadata || {},
      methodDescriptor_GrcImport_GetImportWizardStatus,
      callback);
};


/**
 * @param {!proto.importer.GetImportWizardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.importer.GetImportWizardResponse>}
 *     Promise that resolves to the response
 */
proto.importer.GrcImportPromiseClient.prototype.getImportWizardStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/importer.GrcImport/GetImportWizardStatus',
      request,
      metadata || {},
      methodDescriptor_GrcImport_GetImportWizardStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.importer.GetImportWizardPoliciesRequest,
 *   !proto.importer.GetImportWizardPoliciesResponse>}
 */
const methodDescriptor_GrcImport_GetImportWizardPolicies = new grpc.web.MethodDescriptor(
  '/importer.GrcImport/GetImportWizardPolicies',
  grpc.web.MethodType.UNARY,
  proto.importer.GetImportWizardPoliciesRequest,
  proto.importer.GetImportWizardPoliciesResponse,
  /**
   * @param {!proto.importer.GetImportWizardPoliciesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.importer.GetImportWizardPoliciesResponse.deserializeBinary
);


/**
 * @param {!proto.importer.GetImportWizardPoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.importer.GetImportWizardPoliciesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.importer.GetImportWizardPoliciesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.importer.GrcImportClient.prototype.getImportWizardPolicies =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/importer.GrcImport/GetImportWizardPolicies',
      request,
      metadata || {},
      methodDescriptor_GrcImport_GetImportWizardPolicies,
      callback);
};


/**
 * @param {!proto.importer.GetImportWizardPoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.importer.GetImportWizardPoliciesResponse>}
 *     Promise that resolves to the response
 */
proto.importer.GrcImportPromiseClient.prototype.getImportWizardPolicies =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/importer.GrcImport/GetImportWizardPolicies',
      request,
      metadata || {},
      methodDescriptor_GrcImport_GetImportWizardPolicies);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.importer.GetImportWizardControlsRequest,
 *   !proto.importer.GetImportWizardControlsResponse>}
 */
const methodDescriptor_GrcImport_GetImportWizardControls = new grpc.web.MethodDescriptor(
  '/importer.GrcImport/GetImportWizardControls',
  grpc.web.MethodType.UNARY,
  proto.importer.GetImportWizardControlsRequest,
  proto.importer.GetImportWizardControlsResponse,
  /**
   * @param {!proto.importer.GetImportWizardControlsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.importer.GetImportWizardControlsResponse.deserializeBinary
);


/**
 * @param {!proto.importer.GetImportWizardControlsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.importer.GetImportWizardControlsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.importer.GetImportWizardControlsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.importer.GrcImportClient.prototype.getImportWizardControls =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/importer.GrcImport/GetImportWizardControls',
      request,
      metadata || {},
      methodDescriptor_GrcImport_GetImportWizardControls,
      callback);
};


/**
 * @param {!proto.importer.GetImportWizardControlsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.importer.GetImportWizardControlsResponse>}
 *     Promise that resolves to the response
 */
proto.importer.GrcImportPromiseClient.prototype.getImportWizardControls =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/importer.GrcImport/GetImportWizardControls',
      request,
      metadata || {},
      methodDescriptor_GrcImport_GetImportWizardControls);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.importer.GetImportWizardEvidenceRequest,
 *   !proto.importer.GetImportWizardEvidenceResponse>}
 */
const methodDescriptor_GrcImport_GetImportWizardEvidence = new grpc.web.MethodDescriptor(
  '/importer.GrcImport/GetImportWizardEvidence',
  grpc.web.MethodType.UNARY,
  proto.importer.GetImportWizardEvidenceRequest,
  proto.importer.GetImportWizardEvidenceResponse,
  /**
   * @param {!proto.importer.GetImportWizardEvidenceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.importer.GetImportWizardEvidenceResponse.deserializeBinary
);


/**
 * @param {!proto.importer.GetImportWizardEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.importer.GetImportWizardEvidenceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.importer.GetImportWizardEvidenceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.importer.GrcImportClient.prototype.getImportWizardEvidence =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/importer.GrcImport/GetImportWizardEvidence',
      request,
      metadata || {},
      methodDescriptor_GrcImport_GetImportWizardEvidence,
      callback);
};


/**
 * @param {!proto.importer.GetImportWizardEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.importer.GetImportWizardEvidenceResponse>}
 *     Promise that resolves to the response
 */
proto.importer.GrcImportPromiseClient.prototype.getImportWizardEvidence =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/importer.GrcImport/GetImportWizardEvidence',
      request,
      metadata || {},
      methodDescriptor_GrcImport_GetImportWizardEvidence);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.importer.UpdateImportWizardPoliciesRequest,
 *   !proto.importer.UpdateImportWizardResponse>}
 */
const methodDescriptor_GrcImport_UpdateImportWizardPolicies = new grpc.web.MethodDescriptor(
  '/importer.GrcImport/UpdateImportWizardPolicies',
  grpc.web.MethodType.UNARY,
  proto.importer.UpdateImportWizardPoliciesRequest,
  proto.importer.UpdateImportWizardResponse,
  /**
   * @param {!proto.importer.UpdateImportWizardPoliciesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.importer.UpdateImportWizardResponse.deserializeBinary
);


/**
 * @param {!proto.importer.UpdateImportWizardPoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.importer.UpdateImportWizardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.importer.UpdateImportWizardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.importer.GrcImportClient.prototype.updateImportWizardPolicies =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/importer.GrcImport/UpdateImportWizardPolicies',
      request,
      metadata || {},
      methodDescriptor_GrcImport_UpdateImportWizardPolicies,
      callback);
};


/**
 * @param {!proto.importer.UpdateImportWizardPoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.importer.UpdateImportWizardResponse>}
 *     Promise that resolves to the response
 */
proto.importer.GrcImportPromiseClient.prototype.updateImportWizardPolicies =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/importer.GrcImport/UpdateImportWizardPolicies',
      request,
      metadata || {},
      methodDescriptor_GrcImport_UpdateImportWizardPolicies);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.importer.UpdateImportWizardControlsRequest,
 *   !proto.importer.UpdateImportWizardResponse>}
 */
const methodDescriptor_GrcImport_UpdateImportWizardControls = new grpc.web.MethodDescriptor(
  '/importer.GrcImport/UpdateImportWizardControls',
  grpc.web.MethodType.UNARY,
  proto.importer.UpdateImportWizardControlsRequest,
  proto.importer.UpdateImportWizardResponse,
  /**
   * @param {!proto.importer.UpdateImportWizardControlsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.importer.UpdateImportWizardResponse.deserializeBinary
);


/**
 * @param {!proto.importer.UpdateImportWizardControlsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.importer.UpdateImportWizardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.importer.UpdateImportWizardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.importer.GrcImportClient.prototype.updateImportWizardControls =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/importer.GrcImport/UpdateImportWizardControls',
      request,
      metadata || {},
      methodDescriptor_GrcImport_UpdateImportWizardControls,
      callback);
};


/**
 * @param {!proto.importer.UpdateImportWizardControlsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.importer.UpdateImportWizardResponse>}
 *     Promise that resolves to the response
 */
proto.importer.GrcImportPromiseClient.prototype.updateImportWizardControls =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/importer.GrcImport/UpdateImportWizardControls',
      request,
      metadata || {},
      methodDescriptor_GrcImport_UpdateImportWizardControls);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.importer.UpdateImportWizardEvidenceRequest,
 *   !proto.importer.UpdateImportWizardResponse>}
 */
const methodDescriptor_GrcImport_UpdateImportWizardEvidence = new grpc.web.MethodDescriptor(
  '/importer.GrcImport/UpdateImportWizardEvidence',
  grpc.web.MethodType.UNARY,
  proto.importer.UpdateImportWizardEvidenceRequest,
  proto.importer.UpdateImportWizardResponse,
  /**
   * @param {!proto.importer.UpdateImportWizardEvidenceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.importer.UpdateImportWizardResponse.deserializeBinary
);


/**
 * @param {!proto.importer.UpdateImportWizardEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.importer.UpdateImportWizardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.importer.UpdateImportWizardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.importer.GrcImportClient.prototype.updateImportWizardEvidence =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/importer.GrcImport/UpdateImportWizardEvidence',
      request,
      metadata || {},
      methodDescriptor_GrcImport_UpdateImportWizardEvidence,
      callback);
};


/**
 * @param {!proto.importer.UpdateImportWizardEvidenceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.importer.UpdateImportWizardResponse>}
 *     Promise that resolves to the response
 */
proto.importer.GrcImportPromiseClient.prototype.updateImportWizardEvidence =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/importer.GrcImport/UpdateImportWizardEvidence',
      request,
      metadata || {},
      methodDescriptor_GrcImport_UpdateImportWizardEvidence);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.importer.CancelImportWizardRequest,
 *   !proto.importer.CancelImportWizardResponse>}
 */
const methodDescriptor_GrcImport_CancelImportWizard = new grpc.web.MethodDescriptor(
  '/importer.GrcImport/CancelImportWizard',
  grpc.web.MethodType.UNARY,
  proto.importer.CancelImportWizardRequest,
  proto.importer.CancelImportWizardResponse,
  /**
   * @param {!proto.importer.CancelImportWizardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.importer.CancelImportWizardResponse.deserializeBinary
);


/**
 * @param {!proto.importer.CancelImportWizardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.importer.CancelImportWizardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.importer.CancelImportWizardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.importer.GrcImportClient.prototype.cancelImportWizard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/importer.GrcImport/CancelImportWizard',
      request,
      metadata || {},
      methodDescriptor_GrcImport_CancelImportWizard,
      callback);
};


/**
 * @param {!proto.importer.CancelImportWizardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.importer.CancelImportWizardResponse>}
 *     Promise that resolves to the response
 */
proto.importer.GrcImportPromiseClient.prototype.cancelImportWizard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/importer.GrcImport/CancelImportWizard',
      request,
      metadata || {},
      methodDescriptor_GrcImport_CancelImportWizard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.importer.FinalizeImportWizardRequest,
 *   !proto.importer.FinalizeImportWizardResponse>}
 */
const methodDescriptor_GrcImport_FinalizeImportWizard = new grpc.web.MethodDescriptor(
  '/importer.GrcImport/FinalizeImportWizard',
  grpc.web.MethodType.UNARY,
  proto.importer.FinalizeImportWizardRequest,
  proto.importer.FinalizeImportWizardResponse,
  /**
   * @param {!proto.importer.FinalizeImportWizardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.importer.FinalizeImportWizardResponse.deserializeBinary
);


/**
 * @param {!proto.importer.FinalizeImportWizardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.importer.FinalizeImportWizardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.importer.FinalizeImportWizardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.importer.GrcImportClient.prototype.finalizeImportWizard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/importer.GrcImport/FinalizeImportWizard',
      request,
      metadata || {},
      methodDescriptor_GrcImport_FinalizeImportWizard,
      callback);
};


/**
 * @param {!proto.importer.FinalizeImportWizardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.importer.FinalizeImportWizardResponse>}
 *     Promise that resolves to the response
 */
proto.importer.GrcImportPromiseClient.prototype.finalizeImportWizard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/importer.GrcImport/FinalizeImportWizard',
      request,
      metadata || {},
      methodDescriptor_GrcImport_FinalizeImportWizard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.importer.GetFinalizeImportWizardStatusRequest,
 *   !proto.importer.GetFinalizeImportWizardStatusResponse>}
 */
const methodDescriptor_GrcImport_GetFinalizeImportWizardStatus = new grpc.web.MethodDescriptor(
  '/importer.GrcImport/GetFinalizeImportWizardStatus',
  grpc.web.MethodType.UNARY,
  proto.importer.GetFinalizeImportWizardStatusRequest,
  proto.importer.GetFinalizeImportWizardStatusResponse,
  /**
   * @param {!proto.importer.GetFinalizeImportWizardStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.importer.GetFinalizeImportWizardStatusResponse.deserializeBinary
);


/**
 * @param {!proto.importer.GetFinalizeImportWizardStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.importer.GetFinalizeImportWizardStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.importer.GetFinalizeImportWizardStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.importer.GrcImportClient.prototype.getFinalizeImportWizardStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/importer.GrcImport/GetFinalizeImportWizardStatus',
      request,
      metadata || {},
      methodDescriptor_GrcImport_GetFinalizeImportWizardStatus,
      callback);
};


/**
 * @param {!proto.importer.GetFinalizeImportWizardStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.importer.GetFinalizeImportWizardStatusResponse>}
 *     Promise that resolves to the response
 */
proto.importer.GrcImportPromiseClient.prototype.getFinalizeImportWizardStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/importer.GrcImport/GetFinalizeImportWizardStatus',
      request,
      metadata || {},
      methodDescriptor_GrcImport_GetFinalizeImportWizardStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.importer.AutoCollectRequest,
 *   !proto.importer.AutoCollectResponse>}
 */
const methodDescriptor_GrcImport_AutoCollect = new grpc.web.MethodDescriptor(
  '/importer.GrcImport/AutoCollect',
  grpc.web.MethodType.UNARY,
  proto.importer.AutoCollectRequest,
  proto.importer.AutoCollectResponse,
  /**
   * @param {!proto.importer.AutoCollectRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.importer.AutoCollectResponse.deserializeBinary
);


/**
 * @param {!proto.importer.AutoCollectRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.importer.AutoCollectResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.importer.AutoCollectResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.importer.GrcImportClient.prototype.autoCollect =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/importer.GrcImport/AutoCollect',
      request,
      metadata || {},
      methodDescriptor_GrcImport_AutoCollect,
      callback);
};


/**
 * @param {!proto.importer.AutoCollectRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.importer.AutoCollectResponse>}
 *     Promise that resolves to the response
 */
proto.importer.GrcImportPromiseClient.prototype.autoCollect =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/importer.GrcImport/AutoCollect',
      request,
      metadata || {},
      methodDescriptor_GrcImport_AutoCollect);
};


module.exports = proto.importer;

